import React from 'react'
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon, ClockIcon, XCircleIcon, CalendarDaysIcon } from "lucide-react";
import { AiOutlineCheckCircle, AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineExclamationCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import { MdTrendingUp, MdTrendingDown } from "react-icons/md";

const useAnalysis = () => {

    const getStatusIcon = (status: string | boolean) => {
        switch (status) {
            case 'active':
            case true:
                return <CheckCircleIcon className="h-5 w-5 text-green-500" />;
            case 'pending':
            case false:
                return <ClockIcon className="h-5 w-5 text-yellow-500" />;
            case 'expired':
                return <ExclamationCircleIcon className="h-5 w-5 text-red-500" />;
            case 'cancelled':
                return <XCircleIcon className="h-5 w-5 text-gray-500" />;
            case 'suspended':
                return <CalendarDaysIcon className="h-5 w-5 text-orange-500" />;
            default:
                return null;
        }
    };

    const getStatusColor = (status: string | boolean): string => {
        switch (status) {
            case 'active':
            case true:
                return 'bg-green-100 text-green-800';
            case 'pending':
            case false:
                return 'bg-yellow-100 text-yellow-800';
            case 'expired':
                return 'bg-red-100 text-red-800';
            case 'cancelled':
                return 'bg-gray-100 text-gray-800';
            case 'suspended':
                return 'bg-orange-100 text-orange-800';
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const getKycStatusInfo = (status: string | boolean) => {
        switch (status) {
            case 'verified':
            case true:
                return {
                    color: 'bg-green-100 text-green-800',
                    icon: <AiOutlineCheckCircle className="h-4 w-4 text-green-500" />
                };
            case 'pending':
            case false:
                return {
                    color: 'bg-red-100 text-yellow-800',
                    icon: <AiOutlineClockCircle className="h-4 w-4 text-red-300" />
                };
            case 'rejected':
                return {
                    color: 'bg-red-100 text-red-800',
                    icon: <AiOutlineCloseCircle className="h-4 w-4 text-red-500" />
                };
            case 'expired':
                return {
                    color: 'bg-orange-100 text-orange-800',
                    icon: <AiOutlineExclamationCircle className="h-4 w-4 text-orange-500" />
                };
            default:
                return {
                    color: 'bg-gray-100 text-gray-800',
                    icon: <AiOutlineQuestionCircle className="h-4 w-4 text-gray-500" />
                };
        }
    };


    const getRiskScoreInfo = (score: number) => {
        if (score <= 30) {
            return {
                color: 'bg-green-100 text-green-800',
                icon: <MdTrendingUp className="h-4 w-4 text-green-500" />
            };
        } else if (score <= 70) {
            return {
                color: 'bg-yellow-100 text-yellow-800',
                icon: <AiOutlineExclamationCircle className="h-4 w-4 text-yellow-500" />
            };
        } else {
            return {
                color: 'bg-red-100 text-red-800',
                icon: <MdTrendingDown className="h-4 w-4 text-red-500" />
            };
        }
    };
    return {
        getStatusIcon,
        getStatusColor,
        getKycStatusInfo,
        getRiskScoreInfo
    }
}

export default useAnalysis